import React from 'react'

import styled from 'styled-components'

import colors from '../../css/colors.scss'
import {
    Container,
    Row,
    devices,
} from '../Common'


export const Footer = () => {
    return (
        <FooterWrap>
            <FooterContainer>
                <FooterRow>
                    <FooterInfoWrap>
                    </FooterInfoWrap>
                    <FooterMenu width={30} margintop={30}>
                    </FooterMenu>
                </FooterRow>
            </FooterContainer>
        </FooterWrap>
    )
}

const FooterWrap = styled.footer`
    padding-top: 50px;
    padding-bottom: 50px;
    background: ${colors.darkGreen};
    color: ${colors.white};
`

const FooterContainer = styled(Container)`
    max-width: 1400px;
`

const FooterRow = styled(Row)`
    @media ${devices.mobile} {
        flex-direction: column;
        padding: 0 20px;
    }
`

const FooterInfoWrap = styled.div`
    width: calc(100% - 330px);
    max-width: 540px;
    padding-right: 60px;

    @media ${devices.mobile} {
        width: 100%;
        max-width: 100%;
        padding-right: 0;
    }
`

const FooterMenu = styled.div`
    width: 400px;
    @media ${devices.mobile} {
        width: 100%;
        border-top: 1px solid ${colors.white};
        padding-top: 20px;
        margin-top: 20px;
    }
`
